import { all, takeLatest, put, call } from 'redux-saga/effects';

import { AxiosResponse } from 'axios';

import api from 'services/api';

import { ITrackReopenTypes, ITrackReopenError } from './types';

import {
  trackReopenRequest,
  trackReopenSuccess,
  trackReopenFailure,
} from './actions';

type ITrackReopenType = ReturnType<typeof trackReopenRequest>;

export function* tracksReopenRequest({ payload }: ITrackReopenType) {
  try {
    const { called, description, file } = payload;

    const formData = new FormData();
    formData.append('chamado', called);
    formData.append('descricao', String(description));
    for (let i = 0; i < file.length; i += 1) {
      formData.append('anexo', file[i]);
    }

    const { data }: AxiosResponse<ITrackReopenError> = yield call(
      api.post,
      '/portal-conecta/reabrir-chamados',
      formData,
    );

    if (data.success === false) {
      const response = {
        status: data.status,
        message: data.message,
        success: data.success,
      };

      yield put(trackReopenFailure(response));
    } else {
      yield put(trackReopenSuccess());
    }
  } catch (err) {
    if (err && err?.response) {
      const response = {
        status: err.response?.status,
        message: err.response?.data.message,
      };

      yield put(trackReopenFailure(response));
      return;
    }

    yield put(
      trackReopenFailure({
        status: 500,
        message: 'Erro interno de servidor',
      }),
    );
  } finally {
    const { handleClickNextStep } = payload;
    handleClickNextStep();
  }
}

export default all([
  takeLatest(ITrackReopenTypes.TRACK_REOPEN_REQUEST, tracksReopenRequest),
]);
